import { render, staticRenderFns } from "./CustomerSelector.vue?vue&type=template&id=842e6814&"
import script from "./CustomerSelectorVue.ts?vue&type=script&lang=ts&"
export * from "./CustomerSelectorVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports